<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />
    <draggable :list="quotes" handle=".grabbable">
      <div class="card mb-3" v-for="(quote, index) in quotes" :key="index">
        <div class="card-header d-flex justify-content-between">
          <i class="fas fa-bars grabbable"></i>
          <button
            @click="deleteQuote(index)"
            class="btn btn-outline-danger btn-sm"
          >
            {{ 'Delete' | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label>{{ 'Name' | translate }}</label>
            <input
              class="form-control"
              type="text"
              v-model="quote.source"
              :placeholder="$t('Quote source')"
            />
          </div>
          <div class="mb-3">
            <label>{{ 'Url' | translate }}</label>
            <input
              class="form-control"
              type="text"
              v-model="quote.url"
              :placeholder="$t('Source url')"
            />
          </div>
          <div class="mb-3">
            <label>{{ 'Additional info' | translate }}</label>
            <input
              class="form-control"
              type="text"
              v-model="quote.additional_info"
            />
          </div>
          <div class="mb-3">
            <label>{{ 'Quote' | translate }}</label>
            <textarea
              class="form-control"
              v-model="quote.quote"
              :placeholder="$t('Quote')"
              rows="4"
            ></textarea>
          </div>
          <div class="mb-3">
            <ImageUpload
              :file-path="quote.img"
              context="block.columns"
              @fileDeleted="imageDeleted(index, quote)"
              @uploadCompleted="imageUploaded($event, index, quote)"
            ></ImageUpload>
          </div>
        </div>
      </div>
    </draggable>

    <div class="row">
      <div class="col">
        <button @click="addQuote" class="btn btn-primary">
          {{ 'Add' | translate }}
        </button>
      </div>
    </div>

    <div class="mb-3">
      <div class="form-check form-switch mt-2">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="displayAsSlider"
          value="1"
          :id="`display-as-slider-${block.id}`"
        />
        <label
          class="form-check-label"
          :for="`display-as-slider-${block.id}`"
        >
          <small>{{ 'Display as slider' | translate }}</small>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import ImageUpload from './../ImageUpload'
import route from '~/routes.js'

export default {
  components: {
    draggable,
    ImageUpload,
  },
  props: ['block'],
  data() {
    return {
      quotes: this.block.data || [],
    }
  },
  updated() {
    this.updateBlock()
  },
  methods: {
    img(url) {
      if (!url) {
        return false
      }
      return route.image(url)
    },
    imageDeleted(index, quote) {
      this.$set(this.quotes, index, {
        ...quote,
        img: null,
      })
      this.updateBlock()
      this.$emit('saveAndContinue')
    },
    imageUploaded(path, index, quote) {
      this.$set(this.quotes, index, {
        ...quote,
        img: path,
      })
      this.updateBlock()
      this.$emit('saveAndContinue')
    },
    deleteQuote(key) {
      this.$delete(this.quotes, key)
    },
    addQuote() {
      this.quotes.push({
        quote: null,
        source: null,
      })
    },

    updateBlock() {
      this.block.data = this.quotes
    },
  },
  computed: {
    displayAsSlider: {
      get() {
        return _.get(this, 'block.settings.display_as_slider')
      },
      set(value) {
        let settings = _.get(this, 'block.settings', {})
        this.$set(this.block, 'settings', {
          ...settings,
          display_as_slider: value,
        })
      },
    },
  },
}
</script>
